var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fab",class:_vm.postButtonStyle,attrs:{"id":"fab"},on:{"click":function($event){return _vm.clickItem()}}},[_c('v-icon',{staticClass:"icon",attrs:{"name":"pencil-alt","scale":"2","color":"#ffffff"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a54040","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostingButton.vue
// module id = 521
// module chunks = 1